var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { uuid } from "./uuid";
import { getDetails } from "./getBankDetails";
import { patchOrder } from "./ordersApi";
import toast from "react-hot-toast";
import { getUserProfileDetails } from "./userProfile";
const uploadQuoteToS3 = (fileName, binaryData) => __awaiter(void 0, void 0, void 0, function* () {
    const uploadName = fileName.split(" ").join("") + uuid();
    const applicationId = process.env.REACT_APP_APPLICATION_ID;
    const b = new Blob([binaryData], { type: "application/xlsx" });
    const file = new File([b], `${uploadName}.xlsx`, {
        type: "application/xlsx",
    });
    const authToken = localStorage.getItem("token");
    const configGetS3Url = {
        url: `${process.env.REACT_APP_HELLOAR_API}signed_file`,
        params: {
            file_name: `${uploadName}.xlsx`,
            file_type: "application/xlsx",
            application_id: applicationId,
        },
        headers: { Authorization: authToken },
    };
    try {
        const response = yield axios.request(configGetS3Url);
        let formData = new FormData();
        let key;
        for (key in response.data.data.fields) {
            formData.append(key, response.data.data.fields[key]);
        }
        formData.append("file", file);
        yield axios.post(response.data.data.url, formData);
        return response.data.uploaded_url;
    }
    catch (err) {
        throw new Error("Error while uploading content" + JSON.stringify(err));
    }
});
export const generateQuote = (order, discountPercentage, fDPercentage, advancePay, edtimatedDelivery) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    toast.loading("Do not refresh the page while the quote is being generated", {
        duration: 5000,
    });
    const userDetails = yield getUserProfileDetails();
    const { address, bank_details, gst_number, } = yield getDetails();
    const user = localStorage.getItem("user");
    const userData = user && JSON.parse(user);
    const cartDataPromises = order.cart_items.map((item, index) => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        return {
            "SI.No": index + 1,
            Description: item.product,
            NoOfSeats: (_b = item.noOfSeats) !== null && _b !== void 0 ? _b : 1,
            "Reference Image": item.thumbnail,
            Quantity: item.quantity,
            Unit: "Nos",
            "Special Unit Price": item.cost,
            Price: item.quantity * item.cost,
            Specifications: item.quote,
        };
    }));
    // Wait for all cartData promises to resolve
    const cartData = yield Promise.all(cartDataPromises);
    const d = new Date();
    const gst = 18 / 100;
    const orderTotal = order.cart_items.reduce((acc, curr) => acc + (curr.cost * curr.quantity || 0), 0);
    const discountedPrice = Number((orderTotal * (discountPercentage / 100)).toFixed(2));
    const freightAndDamage = Number(((orderTotal - discountedPrice) * (fDPercentage / 100)).toFixed(2));
    const amountPayable = orderTotal - discountedPrice + freightAndDamage;
    const gstAmount = (amountPayable * gst).toFixed(2);
    const amountPayableWithGst = Number((amountPayable + amountPayable * gst).toFixed(2));
    const quotationData = {
        template_file_id: "1s9QMPn6J9i3UlEsjnvJHI96sgnl-qNCvCkX_ES84xms",
        type: "sheets",
        optional_parameters: {
            Date: d.toLocaleDateString(),
            Client_Name: order.custom_data.company_name,
            Client_Location: order.customer.location,
            Salesforce_Id: order.lead_id,
            Address: address,
            DELIVERY_TIME: edtimatedDelivery,
            QUOTE_VALIDITY: "60 days",
            ORDER_TOTAL: `${orderTotal - discountedPrice}`,
            ADVANCE_PERCENTAGE: `${advancePay}%`,
            BANK_NAME: bank_details.bank_name,
            BANK_BRANCH: bank_details.branch,
            BENEFICIARY_NAME: bank_details.beneficiary_name,
            ACCOUNT_TYPE: bank_details.account_type,
            ACCOUNT_NUMBER: bank_details.account_number,
            IFSC: bank_details.ifsc,
            SWIFTCODE: bank_details.swift_code,
            MICRCODE: bank_details.micr,
            QUOTE_GENERATOR_NAME: `${userData.first_name} ${userData.last_name}`,
            DISCOUNT_PERCENTAGE: `${discountPercentage}%`,
            FREIGHT_PERCENTAGE: `${fDPercentage}%`,
            DISCOUNT_AMOUNT: `${discountedPrice}`,
            FREIGHT_AMOUNT: `${freightAndDamage}`,
            GST_AMOUNT: gstAmount.toString(),
            GRAND_TOTAL: `${amountPayableWithGst}`,
            GST_NUMBER: gst_number ? gst_number : "",
            DESIGNATION: ((_a = userDetails === null || userDetails === void 0 ? void 0 : userDetails.custom_data) === null || _a === void 0 ? void 0 : _a.designation) || "",
        },
        order: [...cartData],
    };
    try {
        console.error(quotationData, "quotationdata ");
        const res = yield axios.post("https://docgenerator-n3drlt7x5a-el.a.run.app/generate-invoice-embedded-image", quotationData, {
            responseType: "arraybuffer",
        });
        const quoteUrl = yield uploadQuoteToS3(order.customer.name, res.data);
        const updatedOrder = Object.assign(Object.assign({}, order), { documents: {
                xls: quoteUrl,
            } });
        yield patchOrder(updatedOrder);
        return updatedOrder;
    }
    catch (error) {
        window.alert("Unable to generate quotation.");
    }
});
